"use strict";

// returns the size + quotation marks for "inches". (eg. 8x10")
module.exports = function (accumulator, order, product, component) {
  var addition = "".concat(component.size, "\"");

  if (accumulator.length) {
    return accumulator + ' ' + addition;
  }

  return addition;
};